module.exports = __webpack_public_path__ + "static/media/bootstrap-landing-page-about.95809509.jpg";